const LineChartSkeleton = () => {
  return (
    <div style={{ 
      width: '100%', 
      minHeight: '450px',
      display: 'flex',
      flexDirection: 'column',
      gap: '24px',
      padding: '32px'
    }}>
      {/* Stats Header Skeleton */}
      <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
        <div className="placeholder-glow flex-grow-1">
          <span className="placeholder col-md-4 col-6 rounded mb-2 d-block" 
                style={{ height: '24px' }}></span>
          <span className="placeholder col-md-3 col-4 rounded d-block" 
                style={{ height: '16px' }}></span>
        </div>
        <div className="d-flex gap-3 flex-wrap">
          {[1, 2].map(i => (
            <div key={i} className="placeholder-glow text-end">
              <span className="placeholder rounded mb-1 d-block" 
                    style={{ width: '100px', height: '14px' }}></span>
              <span className="placeholder rounded d-block" 
                    style={{ width: '100px', height: '20px' }}></span>
            </div>
          ))}
        </div>
      </div>

      {/* Mini Stats Grid Skeleton */}
      <div className="row g-3 d-none d-md-flex">
        {[1, 2, 3, 4].map(i => (
          <div key={i} className="col-md-3 col-sm-6">
            <div className="p-3 rounded bg-light">
              <div className="placeholder-glow">
                <span className="placeholder col-8 rounded mb-2 d-block" 
                      style={{ height: '14px' }}></span>
                <span className="placeholder col-6 rounded mb-1 d-block" 
                      style={{ height: '18px' }}></span>
                <span className="placeholder col-10 rounded d-block" 
                      style={{ height: '12px' }}></span>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Chart Area Skeleton */}
      <div style={{ 
        height: '380px', 
        background: 'linear-gradient(135deg, #f8fafc 0%, #e0e7ff 100%)',
        borderRadius: '12px',
        display: 'flex',
        alignItems: 'flex-end',
        padding: '20px',
        gap: '8px',
        overflow: 'hidden'
      }}>
        {/* Simulated bars */}
        {Array.from({ length: 12 }).map((_, i) => (
          <div 
            key={i}
            className="placeholder bg-primary"
            style={{ 
              flex: 1,
              height: `${Math.random() * 60 + 20}%`,
              borderRadius: '4px 4px 0 0',
              opacity: 0.4,
              animation: `pulse ${1.2 + (i * 0.1)}s ease-in-out infinite`
            }}
          ></div>
        ))}
      </div>

      {/* Legend Skeleton */}
      <div className="d-flex justify-content-center gap-3 flex-wrap">
        {[1, 2, 3].map(i => (
          <div key={i} className="placeholder-glow">
            <span className="placeholder rounded-pill" 
                  style={{ 
                    width: '120px', 
                    height: '36px',
                    display: 'inline-block'
                  }}></span>
          </div>
        ))}
      </div>

      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 0.3; }
          50% { opacity: 0.6; }
        }
      `}</style>
    </div>
  );
};

export default LineChartSkeleton;